export default __webpack_public_path__ + "madfit-screen-fifth@2x.d58af7a0.png";